import {Grid} from '@material-ui/core';
import React, {useState} from 'react';
import Button from "@material-ui/core/Button";
import {Toaster, toast} from "sonner";
import {makeStyles} from "@material-ui/styles";
import IndexHeader from '../Index/IndexHeader';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import PreviewTemplate from './PreviewTemplate';
import {sendEmailDB} from '../../../firebase';
import ErrorIcon from '@material-ui/icons/Error';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ConfirmDialog from '../ConfirmDialog';


function MoverTemplate(props) {
    const cn = useStyles();

    const [formData, setFormData] = useState({
        to:'',
        subject:'',
        initialText: props.templateData.data[0].args[0].text,
        moverName: props.templateData.data[0].moverName,
        detailsArg: props.templateData.data[0].args[1].details,
        footerText: props.templateData.data[0].args[2].text,
     });

    const [errors, setErrors] = useState({});
    const [confirm, setConfirm] = useState(false);
    const [emails, setEmails] = useState([]);
    const [inputValue, setInputValue] = useState("");
    const [loading, setLoading] = useState(false);

  const handleInputChange2 = (e) => {
    setInputValue(e.target.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === " " || e.key === "Enter") {
      e.preventDefault();
      const email = inputValue.trim();
        if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) 
            if (!emails.some((item) => item.email === email)) {
            setEmails((prevEmails) => [
                ...prevEmails,
                {email: email, name: ""},
            ]);
            setInputValue(""); 
            } else {
                toast.error('This email has already been added' , {
                    position: 'bottom-left',
                    closeButton: true,
                    icon: <ErrorIcon htmlColor="#e74c3c" />,
                  });
            }
         else if (email) 
            toast.error('Ivalid email format' , {
                position: 'bottom-left',
                closeButton: true,
                icon: <ErrorIcon htmlColor="#e74c3c" />,
            });
        
        }
    };

    const removeEmail = (indexToRemove) => {
            setEmails((prevEmails) => prevEmails.filter((_, index) => index !== indexToRemove));
    };

    const handleInputChange = (event) => {
        const {name, value} = event.target;
    
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
    };

    const handleAddDetail = () => {
        setFormData((prevData) => ({
          ...prevData,
          detailsArg: [...(prevData.detailsArg || []), {k: '', v: ''}],
        }));
      };
      
      const handleRemoveDetail = (index) => {
        setFormData((prevData) => {
          const updatedDetails = prevData.detailsArg.slice(); 
          updatedDetails.splice(index, 1); 
          return {...prevData, detailsArg: updatedDetails};
        });
      };
      const validateForm = () => {
        const newErrors = {};
        if (!formData.to.trim()) 
          newErrors.to = 'the field is required';
        
        if (!formData.subject.trim()) 
            newErrors.subject = 'the field is required';
          
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0; 
      };

  const handleSendEmail= () => {
    if (validateForm()) {
        const filteredDetails = formData.detailsArg.filter((detail) => detail.k.trim() !== '' && detail.v.trim() !== '');
        const cleanedFormData = {
          ...formData,
          detailsArg: filteredDetails,
        };
        setLoading(true);
        //setConfirm(false);
        const sendEmail = async () => {
            const payload = {
                to: [{
                    email:formData.to,
                    name:'',
                }],
                cc: emails,
                subject: formData.subject,
                moverName: formData.moverName,
                args: [
                    {text: formData.initialText},
                    {details: cleanedFormData.detailsArg},
                    {text: formData.footerText},
                ],
            }
        
            try {
                await sendEmailDB(props.templateData.templateId,payload);
                setLoading(false);
                setConfirm(false);
                toast.info(`Email sent successfully!`, {
                position: 'bottom-left',
                closeButton: true,
                icon: <CheckCircleIcon htmlColor="#2ecc71"/>,
              });
              setErrors({});
              props.setIsTemplateOpen(false)
            } catch (e) {
             setConfirm(false);
             setLoading(false);
              toast.error('Oops! An error occurred', {
                position: 'bottom-left',
                closeButton: true,
                icon: <ErrorIcon htmlColor="#e74c3c" />,
              });
            }
          }
          sendEmail();

   
      } else {
        setConfirm(false)
      }
  };

    return (
        <div className={cn.templatesIndex}>
            <IndexHeader title={props.templateData.name} />
            <Button
                classes={{root: cn.backButton}}
                variant="contained"
                onClick={()=>props.setIsTemplateOpen(false)}
                >
                <span className={cn.buttonLabel}>Back</span>
            </Button>
            <div className={cn.templateDetail}>
                <div className={cn.halfdiv1}>
                    <div className={cn.formContainer}>
                        <div className={cn.templateTitle}>{"Send email"}</div>
                        <div className={cn.editForm}>
                            <div className={cn.InputField}>
                                <label >To:</label>
                                <input className={cn.inInput} name="to" value={formData.to} onChange={handleInputChange}></input>
                            </div>
                            {errors.to && <span className={cn.textAlert}>{errors.to}</span>}
                         
                            <div className={cn.tagsContainer}>
                                <div>Cc:</div>
                                {emails.map((emailObj, index) => (
                                <div key={index} className={cn.tag}>
                                    {emailObj.email}
                                    <button
                                        type="button"
                                        onClick={() => removeEmail(index)}
                                        className={cn.removeButton}
                                    >
                                    ×
                                    </button>
                                </div>
                                ))}
                                <input
                                    type="text"
                                    value={inputValue}
                                    onChange={handleInputChange2}
                                    onKeyDown={handleKeyDown}
                                    placeholder="Type emails and press Space or Enter"
                                    className={cn.input}
                                />
                            </div>
                            <div className={cn.InputField}>
                                <label >Subject:</label>
                                <input className={cn.inInput} name="subject" value={formData.subject} onChange={handleInputChange}></input>
                            </div>
                            {errors.subject && <span className={cn.textAlert} >{errors.subject}</span>}
                            <div className={cn.InputField}>
                                <label >Mover Name:</label>
                                <input className={cn.inInput} onChange={handleInputChange} name='moverName' value={formData.moverName}></input>
                            </div>
                            <div className={cn.textAreaField}>
                                <label >Initial text:</label>
                                <textarea className={cn.inTextArea} onChange={handleInputChange} name='initialText' value={formData.initialText}></textarea>
                            </div>
                            <div className={cn.label}>Details</div>
                            <div className={cn.detailsTable}>
                            <Grid container spacing={1}>
                               
                            {formData.detailsArg &&  
                             formData.detailsArg.map((m, i) => (
                                <React.Fragment key={i}>
                                    <Grid item xs={6} sm={6} className={cn.padd}>
                                    <div className={cn.InputField}>
                                        <input className={cn.inInput} placeholder='name' value={m.k}
                                        onChange={(e) => {
                                            const updatedDetails = [...formData.detailsArg];
                                            updatedDetails[i].k = e.target.value;
                                            setFormData({...formData, detailsArg: updatedDetails});
                                          }}/>
                                    </div>
                                </Grid>

                                <Grid item xs={6} sm={5}>
                                    <div className={cn.InputField}>
                                        <input className={cn.inInput} placeholder='value' value={m.v}
                                         onChange={(e) => {
                                            const updatedDetails = [...formData.detailsArg];
                                            updatedDetails[i].v = e.target.value;
                                            setFormData({...formData, detailsArg: updatedDetails});
                                          }}/>
                                    </div>
                                </Grid>
                                
                                    {i !== formData.detailsArg.length - 1 && (
                                    <Grid item xs={6} sm={1} className={cn.padT}>
                                        <div className={cn.actionIcon} onClick={() => handleRemoveDetail(i)}>
                                        <RemoveIcon />
                                        </div>
                                    </Grid>
                                    )}

                                    {i === formData.detailsArg.length - 1 && (
                                    <Grid item xs={6} sm={1} className={cn.padT}>
                                        <div className={cn.actionIcon} onClick={handleAddDetail}>
                                        <AddIcon />
                                        </div>
                                    </Grid>
                                    )}
                                </React.Fragment>
                             ))
                            }
                                </Grid>

                                    
                            </div>
                            <div className={cn.textAreaFieldFooter}>
                                <label >Footer text:</label>
                                <textarea className={cn.inTextAreaFooter}  onChange={handleInputChange} name='footerText' value={formData.footerText}></textarea>
                            </div>
                        </div>
                        <div className={cn.sendBTN}>
                            <Button
                                onClick={()=>setConfirm(true)}
                                className={cn.btnClass}
                                disbled = {loading}
                                spaced>
                                Send Email
                            </Button>
                        </div>
                    </div>
                </div>
                <div className={cn.halfdiv}>
                    <PreviewTemplate  initialText={formData.initialText} moverName={formData.moverName} details={formData.detailsArg} footerText={formData.footerText}/>
                </div>
            </div>
            <div>
            </div>
            <ConfirmDialog
                open={confirm}
                handleClose={() => {setConfirm(false); setLoading(false)}}
                handleConfirm={handleSendEmail}
                title={'Confirmation'}
                message={`Are you sure you want to send the email?`}
                disabled={loading}
            />
            <Toaster position="bottom-right"  />
        </div>

    );
};

const useStyles = makeStyles({

    textAlert:{
        fontSize:'10px',
        color: 'red',
        fontWeight:"bold",
    },
    padd:{
        paddingBottom:'0',
    },
    padT:{
        marginTop:'5px',
    },
    sendBTN: {
        display: 'flex',
        justifyContent: 'end',
        marginTop: '15px',
    
    },
    btnClass:{
        background: '#147DC1',
        color: '#fff',
        fontSize: '13px',
        fontWeight: '600',
        '&:hover': {
            background: '#1D92D0', 

        },
    },
    textAreaField: {
        outlineStyle: 'none',
        display: 'block',
        background: '#f3f3f3',
        padding: '7px',
        paddingLeft: '10px',
        minHeight: '150px',
        fontSize: '14px',
        borderRadius: "4px",
        color: '#757575',
        alignItems: 'center',
        marginBottom: '4px',
        marginTop: '4px',
    },
    textAreaFieldFooter: {
        outlineStyle: 'none',
        display: 'block',
        background: '#f3f3f3',
        padding: '7px',
        paddingLeft: '10px',
        minHeight: '100px',
        fontSize: '14px',
        borderRadius: "4px",
        color: '#757575',
        marginBottom: '4px',
        marginTop: '4px',
        alignItems: 'center',
    },
    label: {
        color: '#757575',
        marginBottom: '10px',
    },
    templatesIndex: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        padding: '25px',
    },
  
    templateDetail: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        background: '#f3f3f3',
        padding: '2px 50px 25px 10px',
        marginTop: '15px',

    },
    detailsTable: {
        display: 'flex',
    },

    formContainer: {
        background: "white",
        padding: '15px',
        boxShadow: '4px 4px 10px rgba(0, 0, 0, 0.1)',
    },

    halfdiv1: {
        flex: 1,
        padding: '18px',
    },
    halfdiv: {
        flex: 1,
        padding: '18px',
    },
    backButton: {
        background: 'white',
        width: '100px',
        marginTop: '10px',
    },
    templateTitle: {
        marginTop: '25px',
        fontSize: '23px',
        marginBottom: '25px',
        paddingLeft: '25px',
    },
  
    editForm: {
        display: "flex",
        flexDirection: "column",
        paddingRight: '20px',
        paddingLeft: '20px',
    },
   
    field: {
        fontSize: "12px",
    },
    actionIcon: {
        background: '#f3f3f3',
        display: 'flex',
        height: '43px',
        fontSize:'10px',
        alignItems: 'center',
        padding: '6px',
        color: '#0F75BB',
        cursor:'pointer',
    },
    InputField: {
        outlineStyle: 'none',
        display: 'flex',
        background: '#f3f3f3',
        padding: '7px',
        paddingLeft: '10px',
        height: '45px',
        fontSize: '14px',
        borderRadius: "4px",
        color: '#757575',
        marginBottom: '4px',
        marginTop: '4px',
        alignItems: 'center',
        width: '100%',
    },

    inInput: {
        flex: 1,
        border: 'none',
        background: '#f3f3f3',
        color: "#2B2B2B",
        fontSize: '14px',
        marginLeft: '8px',
        '&:focus': {
            border: 'none', 
            outline: 'none', 
        },
    },

    inTextArea: {
        border: 'none',
        background: '#f3f3f3',
        color: "#2B2B2B",
        minHeight: '120px',
        fontSize: '14px',
        marginLeft: '8px',
        width: '95%',
        '&:focus': {
            border: 'none',
            outline: 'none',
        },
    },
    inTextAreaFooter: {
        border: 'none',
        background: '#f3f3f3',
        color: "#2B2B2B",
        minHeight: '80px',
        fontSize: '14px',
        marginLeft: '8px',
        width: '95%',
        '&:focus': {
            border: 'none',
            outline: 'none',
        },
    },

      tagsContainer: {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        borderRadius: "4px",
        padding: "5px",
        minHeight: "45px",
        outlineStyle: 'none',
        background: '#f3f3f3',
        fontSize:'14px',
      },
      tag: {
        display: "flex",
        alignItems: "center",
        background: "#e0e0e0",
        borderRadius: "4px",
        padding: "5px 10px",
        margin: "5px",
        fontSize: "14px",
      },
      removeButton: {
        marginLeft: "10px",
        background: "transparent",
        border: "none",
        color: "#333",
        fontWeight: "bold",
        cursor: "pointer",
      },
      input: {
        flex: "1",
        border: "none",
        outline: "none",
        fontSize: "14px",
        padding: "5px",
      },
});

export default MoverTemplate;
